<section class="services-messages">
  <div class="row header">
    <div class="col-sm-6">
      @if (service || services?.length === 1) {
      <h2 class="pull-left">Service messages</h2>
      } @if (services?.length > 1) {
      <h2 class="pull-left">Messages</h2>
      }
    </div>

    @if (services?.length > 1) {
    <div class="col-sm-6 text-end">
      <div class="d-flex align-items-center">
        <div class="mb-3">
          <label>Filter messages&nbsp;</label>
          <select
            id="filterElement"
            [(ngModel)]="filterService"
            (ngModelChange)="synchroniseServiceSelectors($event)"
          >
            <option value="" selected>All services</option>
            @for (service of services; track service) {
            <option [ngValue]="service">
              {{ service.name }}
            </option>
            }
          </select>
        </div>
      </div>
    </div>
    }
  </div>
  <p class="intro mt5">
    Post messages to colleagues about this assignment as well as keeping a
    record of phone conversations with the assignee or the client.
  </p>

  <ul class="messages">
    @for (message of messages | filterByService: filterService; track message) {
    <li class="message-block">
      @if (message.postState === 'failed') {
      <div class="message-error">
        Message post failed. We will try it again for you after a while...
      </div>
      }
      <div class="message-body {{ message.postState }}">
        <figure class="avatar">
          <file-jet-img
            [image]="message.author.avatar"
            [width]="50"
            [height]="50"
            [alt]="message.author | userName"
          ></file-jet-img>
        </figure>
        <div class="message-info">
          <dl>
            <dt>K2:</dt>
            @if (message.author.id !== userId) {
            <dd>
              <a [routerLink]="message.author | userLink"></a>
            </dd>
            } @if (message.author.id === userId) {
            <dd>
              <strong>You</strong>
            </dd>
            }
            <dt>Time:&nbsp;</dt>
            <dd><relative-time [iso]="message.created_at"></relative-time></dd>
            <dt>Service:</dt>
            <dd>
              @if (message.services_id) {
              <a
                [routerLink]="[
                  '/staff/clients',
                  clientId,
                  'assignment',
                  assignmentId,
                  'services',
                  message.services_id
                ]"
              >
                {{ findService(message.services_id)?.name }}
              </a>
              } @if (!message.services_id) {
              <span> {{ findService(message.services_id)?.name }}</span>
              }
            </dd>
          </dl>
        </div>
        <service-message-text [text]="message.text"></service-message-text>
      </div>
    </li>
    }
  </ul>

  <div class="message-block">
    <figure class="avatar">
      <file-jet-img
        [image]="currentUserAvatar"
        [width]="50"
        [height]="50"
        [alt]="'avatar'"
      ></file-jet-img>
    </figure>

    <textarea
      [(ngModel)]="draftText"
      class="form-control"
      placeholder="Type your message here"
    ></textarea>

    <div class="d-flex align-items-center message-controls">
      <div class="mb-3">
        @if (services?.length > 1) {
        <span>
          <label>Category&nbsp;</label>
          <select
            [(ngModel)]="selectedService"
            (ngModelChange)="synchroniseServiceSelectors($event)"
          >
            @for (service of services; track service) {
            <option [ngValue]="service">
              {{ service.name }}
            </option>
            }
          </select>
        </span>
        }

        <button (click)="addMessage()" class="btn btn-default">
          Post message
        </button>
      </div>
    </div>
  </div>
</section>
